import { createContext, useContext, useState } from "react";
import axios from "axios";

const PredictionContext = createContext();
// const BASE_URL = "http://localhost:8000";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const PredictionProvider = ({ children }) => {
  const [predictionMap, setPredictionMap] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState();
  const [intradayPredictionMap, setIntradayPredictionMap] = useState({});
  const [intradayLastUpdated, setIntradayLastUpdated] = useState();
  const [combinedPredictionMap, setCombinedPredictionMap] = useState({});
  const [combinedLastUpdated, setCombinedLastUpdated] = useState(null);
  const [combinedIntradayUpdated, setCombinedIntradayUpdated] = useState(null);
  /**
   * symbolsPayload = [{ symbol, securityId }]
   */
  const fetchPredictions = async (symbolsPayload) => {
    if (!Array.isArray(symbolsPayload) || symbolsPayload.length === 0) return;

    setLoading(true);
    setError(null);

    try {
      const { data } = await axios.post(
        `${BASE_URL}/api/batchStocks`,
        symbolsPayload,
      );

      /**
       * Convert array → map for O(1) access
       * predictionMap["RELIANCE"] → prediction
       */
      // const map = {};
      // let maxUpdatedAt = null;
      // data?.data?.forEach((item) => {
      //   map[item.symbol] = item;
      //   if (item.updated_at) {
      //     const t = new Date(item.updated_at).getTime();
      //     if (!maxUpdatedAt || t > maxUpdatedAt) {
      //       maxUpdatedAt = t;
      //     }
      //   }
      // });
      const map = {};
      let latestMarketDate = null;

      data?.data?.forEach((item) => {
        map[item.symbol] = item;

        if (item.market_date) {
          if (!latestMarketDate || item.market_date > latestMarketDate) {
            latestMarketDate = item.market_date;
          }
        }
      });

      setPredictionMap(map);
      if (latestMarketDate) {
        setLastUpdated(latestMarketDate);
      }
      return map;
    } catch (err) {
      console.error("Prediction fetch failed", err);
      setError("Failed to load predictions");
    } finally {
      setLoading(false);
    }
  };

  const fetchIntradayPredictions = async (symbolsPayload) => {
    if (!Array.isArray(symbolsPayload) || symbolsPayload.length === 0) return;

    setLoading(true);
    setError(null);

    try {
      const { data } = await axios.post(
        `${BASE_URL}/api/batchIntradayStocks`,
        symbolsPayload,
      );

      /**
       * Convert array → map for fast lookup
       * intradayPredictionMap["RELIANCE"]
       */
      console.log("Data from intradayPrediction", data);

      const map = {};
      let latestUpdatedAt = null;

      data?.data?.forEach((item) => {
        map[item.symbol] = item;

        if (item.updated_at) {
          const t = new Date(item.data_timestamp).getTime();

          if (!latestUpdatedAt || t > latestUpdatedAt) {
            latestUpdatedAt = t;
          }
        }
      });

      setIntradayPredictionMap(map);

      if (latestUpdatedAt) {
        setIntradayLastUpdated(latestUpdatedAt);
      }

      return map;
    } catch (err) {
      console.error("Intraday prediction fetch failed", err);
      setError("Failed to load intraday predictions");
    } finally {
      setLoading(false);
    }
  };

  const fetchCombinedPredictions = async (symbolsPayload) => {
    if (!Array.isArray(symbolsPayload) || symbolsPayload.length === 0) return;

    setLoading(true);
    setError(null);

    try {
      const { data } = await axios.post(
        `${BASE_URL}/api/combinedPredictions`,
        symbolsPayload,
      );

      const map = {};
      let latestMarketDate = null;
      let latestIntraday = null;

      data?.data?.forEach((item) => {
        map[item.symbol] = item;

        // 🔵 batch date
        if (item.market_date) {
          if (!latestMarketDate || item.market_date > latestMarketDate) {
            latestMarketDate = item.market_date;
          }
        }

        // 🔴 intraday timestamp
        // if (item.data_timestamp) {
        //   const t = new Date(item.data_timestamp).getTime();

        //   if (!latestIntraday || t > latestIntraday) {
        //     latestIntraday = t;
        //   }
        // }
        if (item.data_timestamp) {
          const t = new Date(item.data_timestamp).getTime(); // ✅ use date_timestamp

          if (!latestIntraday || t > latestIntraday) {
            latestIntraday = t;
          }
        }
      });

      // ✅ NEW STATE (separate from existing)
      setCombinedPredictionMap(map);

      if (latestMarketDate) setCombinedLastUpdated(latestMarketDate);
      if (latestIntraday) setCombinedIntradayUpdated(latestIntraday);

      return map;
    } catch (err) {
      console.error("Combined prediction fetch failed", err);
      setError("Failed to load combined predictions");
    } finally {
      setLoading(false);
    }
  };
  const getLatestCandle = (histData) => {
    if (!histData || !histData.close?.length) return null;

    const i = histData.close.length - 1;

    return {
      open: histData.open?.[i],
      high: histData.high?.[i],
      low: histData.low?.[i],
      close: histData.close?.[i],
      prevClose: histData.close?.[i - 1],
    };
  };

  // const fetchIntradayPredictions = async (symbolsPayload) => {
  //   if (!Array.isArray(symbolsPayload) || symbolsPayload.length === 0) return;

  //   setLoading(true);
  //   setError(null);

  //   try {
  //     const { data } = await axios.post(
  //       `${BASE_URL}/api/batchIntradayStocks`,
  //       symbolsPayload,
  //     );

  //     const map = {};
  //     let latestTimestamp = null;

  //     data?.data?.forEach((item) => {
  //       map[item.symbol] = item;

  //       /* 🔵 use candle timestamp */
  //       if (item.data_timestamp) {
  //         latestTimestamp = item.data_timestamp;
  //       }
  //     });

  //     setIntradayPredictionMap(map);
  //     console.log("Response data")

  //     if (latestTimestamp) {
  //       setIntradayLastUpdated(latestTimestamp);
  //     }

  //     return map;
  //   } catch (err) {
  //     console.error("Intraday prediction fetch failed", err);
  //     setError("Failed to load intraday predictions");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  return (
    <PredictionContext.Provider
      value={{
        predictionMap,
        fetchPredictions,
        loading,
        error,
        lastUpdated,
        fetchIntradayPredictions,
        intradayPredictionMap,
        intradayLastUpdated,
        fetchCombinedPredictions,
        combinedPredictionMap,
        combinedLastUpdated,
        combinedIntradayUpdated,
      }}
    >
      {children}
    </PredictionContext.Provider>
  );
};

export const usePrediction = () => useContext(PredictionContext);
